
import { Vue, Component } from "vue-property-decorator";
import AppSidebar from "@/modules/shared/components/AppSidebar.vue";
import AppNavbar from "@/modules/shared/components/AppNavbar.vue";
import { AuthStoreModule } from "@/modules/auth/store/auth.store";

@Component({
  components: { AppSidebar, AppNavbar },
})
export default class DefaultLayout extends Vue {
  public isToggledMiniSidebar = true;

  public async created(): Promise<void> {
    await AuthStoreModule.fetchSession().catch(() => {});
  }
}
